import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from "axios";
import {removeCookie, setCookie} from "../../utils/cookie";
import router from "next/router";

const URL_API = process.env.URL_API;
const resetURL = `${URL_API}/identity/suppliers/forgot-password`;

export interface ResetResult {
    data: any[];
}

export const resetPasswordApi = createAsyncThunk(
    'account/reset',
    async (account: any, { rejectWithValue }) => {

        try {
            const { data } = await axios.post<ResetResult>(resetURL, account);

            return data;
        } catch (error) {
            // sellsmart-api#4626 ADR-15: carry the HTTP status, so the form can tell a 429 (rate limit) from
            // any other refusal. Guarded: a network error has no response, and a proxy may answer with HTML.
            // @ts-ignore
            const { data: body, status } = error.response ?? {};
            return rejectWithValue({ ...(typeof body === "object" && body !== null ? body : {}), status })
        }
    }
);